import { IsString, IsNotEmpty, IsNumber } from 'class-validator';

export class CreateDeviceDTO {
  @IsNotEmpty()
  @IsString()
  public name!: string;

  public description?: string | undefined;

  @IsNotEmpty()
  public status!: string;

  @IsNotEmpty()
  @IsNumber()
  public createdTime?: number;
}
